import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';

export const rtkAPI = createApi({
  reducerPath: 'api',
  baseQuery: fakeBaseQuery(),
  tagTypes: [],
  endpoints: () => ({}),
  keepUnusedDataFor: 300
});
